<template>
  <div class="ui-checkbox">
    <div class="ui-checkbox-container"
         :class="{ disabled, error, required, isTimezone }">
      <label v-if="$slots.default"
             class="ui-checkbox-label"
             :for="uuid">
        <slot></slot>
      </label>
      <div class="ui-checkbox-wrap">
        <label>
          <input type="checkbox"
                 class="a11y-invisible"
                 :id="uuid"
                 :placeholder="placeholder"
                 :disabled="disabled"
                 :value="value"
                 @change="onInput"
                 @click="onFocus" />
          <i v-if="value"
             class="xi-toggle-on"></i>
          <i v-else
             class="xi-toggle-off"></i>
          <span v-if="value"
                class="status">ON</span>
          <span v-else
                class="status">OFF</span>
        </label>
      </div>
      <i v-if="!disabled && !isTimezone"
         class="xi-close"
         @click="onClear"></i>
      <span v-if="required"
            class="required">
        필수
      </span>
    </div>
    <div v-if="error"
         class="ui-checkbox-error"
         v-html="error">
    </div>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'

export default {
  name: 'UiCheckbox',
  props: {
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      default: '',
      required: true
    },
    error: {
      type: String,
      default: '',
      required: false
    },
    isTimezone: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    onFocus () {
      this.$emit('focus')
    },
    onInput () {
      this.$emit('input', !this.value)
    },
    onClear () {
      this.$emit('input', this.initialValue)
    }
  },
  data () {
    return {
      uuid: uuid.v4(),
      initialValue: this.value
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-checkbox {
  position: relative;
  padding-bottom: 20px;

  .ui-checkbox-container {
    position: relative;
    display: flex;
    align-items: center;
    border-bottom: 2px solid;
    border-bottom-color: $gray;
    transition: border-bottom-color 0.3s ease;

    .ui-checkbox-label {
      flex-grow: 0;
      min-width: 70px;
      flex-basis: 70px;
      padding: 5px 0 5px 7px;
      color: $black;
      opacity: 0.5;
      transition: color 0.3s ease;
    }

    .ui-checkbox-wrap {
      flex-grow: 1;
      padding: 0 30px 0 7px;

      span.status {
        display: inline-block;
        margin: 7px 0 0 -3px;
        font-size: 10px;
        cursor: pointer;
        color: $gray;
      }

      i {
        cursor: pointer;
        vertical-align: middle;
        line-height: 24px;
        font-size: 28px;
        color: $dark;

        &.xi-toggle-off {
          color: $gray;
        }
      }
    }

    .required {
      position: absolute;
      top: 50%;
      right: 7px;
      display: block;
      width: 1px;
      height: 5px;
      border-radius: 20px;
      background-color: $orange;
      color: transparent;
      line-height: 17px;
      padding: 0 2px;
      overflow: hidden;
      font-size: 11px;
      transform: translateY(-50%);
      text-align: center;
      letter-spacing: -1px;
      transition: width 0.3s ease,
                  height 0.3s ease,
                  color 0.3s ease;
    }

    .xi-close {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      color: $black;
      font-size: 12px;
      cursor: pointer;
      opacity: 0;
      transition: color 0.3s ease,
                  right 0.3s ease,
                  opacity 0.3s ease;
    }

    &.isTimezone {
      border-bottom: 0px solid;
    }

    &.disabled {
      border-bottom-color: $white;
    }

    &.error {
      border-bottom-color: $red;
    }

    &:hover {
      border-bottom-color: $blue;

      .ui-checkbox-label {
        color: $blue;
        opacity: 1;
      }

      .xi-close {
        opacity: 0.3;

        &:hover,
        &:active {
          opacity: 0.5;
        }
      }

      .required {
        width: 25px;
        height: 17px;
        color: $white;
      }
    }

    &.required {
      .xi-close {
        right: 20px;
      }

      &:hover {
        .xi-close {
          right: 40px;
        }
      }
    }
  }

  .ui-checkbox-error {
    position: absolute;
    bottom: 5px;
    left: 5px;
    font-size: 12px;
    color: $red;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
